import React from 'react'
import CSS from './LandingPage.module.css';
import {Button} from 'semantic-ui-react';
import { withRouter } from 'react-router';


function Section3(props) {
    
    const gotoRegister=()=>{
        props.history.push('/register')
    }
    return (
        <div className={`${CSS.section3}`}>
            <h1>Register your enterprise with us and join our network</h1>
                <Button onClick={gotoRegister} inverted size="small" className="mt-2" color="green">Register</Button>
        </div> 
    )
}

export default withRouter(Section3) 
